import moment from "moment";

// ADM-3 — small pieces shared by the Admin list and the account panel.

export const Pill = ({ label, tone = "gray" }: { label: string; tone?: "gray" | "red" | "blue" | "amber" }) => {
  const cls = {
    gray: "bg-gray-100 text-gray-600 ring-gray-200 dark:bg-white/5 dark:text-white/60 dark:ring-white/10",
    red: "bg-red-50 text-red-700 ring-red-200/60 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-400/20",
    blue: "bg-blue-50 text-blue-700 ring-blue-200/60 dark:bg-blue-500/10 dark:text-blue-300 dark:ring-blue-400/20",
    amber: "bg-amber-50 text-amber-700 ring-amber-200/60 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-400/20",
  }[tone];
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ${cls}`}>{label}</span>;
};

export const when = (d: string | null) => (d ? moment(d).format("MMM D, YYYY") : "—");

// the brand an account signed up under, in plain words
export const brandLabel = (app: string | null) => {
  if (!app) return "No brand";
  if (app.toLowerCase() === "10mf") return "10MF";
  if (app.toLowerCase() === "launchos") return "Launch OS";
  return app;
};

// "3 hours ago", "Oct 2" — or a dash when there's nothing yet
export const ago = (d: string | null) => {
  if (!d) return "—";
  const m = moment(d);
  return moment().diff(m, "days") < 7 ? m.fromNow() : m.format("MMM D, YYYY");
};

// a short device name from the browser's user-agent text ("Chrome on Mac")
export const deviceLabel = (ua: string | null | undefined) => {
  if (!ua) return "Unknown device";
  const os = /iPhone|iPad/.test(ua) ? "iPhone" : /Android/.test(ua) ? "Android" : /Mac OS X|Macintosh/.test(ua) ? "Mac" : /Windows/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "";
  const browser = /Edg\//.test(ua) ? "Edge" : /Chrome\//.test(ua) ? "Chrome" : /Firefox\//.test(ua) ? "Firefox" : /Safari\//.test(ua) ? "Safari" : /curl|python|node|axios/i.test(ua) ? "Script" : "Browser";
  return os ? `${browser} on ${os}` : browser;
};
